import React from 'react';
import { Button } from './ui/button';
import { AlertTriangle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import useI18n from '../hooks/useI18n';

const ConfirmDialog = ({ open, title, description, confirmLabel = 'Confirm', onConfirm, onCancel, variant = 'destructive' }) => {
  const { t } = useI18n();
  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
        onClick={onCancel}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ duration: 0.15 }}
          className="w-full max-w-sm bg-card border border-border rounded-xl shadow-2xl p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-start gap-3 mb-4">
            <div className={`p-2 rounded-lg shrink-0 ${variant === 'destructive' ? 'bg-destructive/10' : 'bg-amber-50 dark:bg-amber-950/30'}`}>
              <AlertTriangle className={`w-4 h-4 ${variant === 'destructive' ? 'text-destructive' : 'text-amber-600'}`} />
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-1">{title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>
            </div>
          </div>
          <div className="flex items-center justify-end gap-2">
            <Button variant="ghost" size="sm" onClick={onCancel}>{t('confirm.cancel')}</Button>
            <Button
              variant={variant === 'destructive' ? 'destructive' : 'default'}
              size="sm"
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmDialog;
